/** Catálogo c_RegimenFiscal SAT (CFDI 4.0) — uso en selects de UI. */
export const REGIMENES_SAT = [
  { c: "601", n: "General de Ley Personas Morales", pf: false, pm: true },
  { c: "603", n: "Personas Morales con Fines no Lucrativos", pf: false, pm: true },
  { c: "605", n: "Sueldos y Salarios e Ingresos Asimilados a Salarios", pf: true, pm: false },
  { c: "606", n: "Arrendamiento", pf: true, pm: false },
  { c: "607", n: "Régimen de Enajenación o Adquisición de Bienes", pf: true, pm: false },
  { c: "608", n: "Demás ingresos", pf: true, pm: false },
  { c: "610", n: "Residentes en el Extranjero sin Establecimiento Permanente en México", pf: true, pm: true },
  { c: "611", n: "Ingresos por Dividendos (socios y accionistas)", pf: true, pm: false },
  { c: "612", n: "Personas Físicas con Actividades Empresariales y Profesionales", pf: true, pm: false },
  { c: "614", n: "Ingresos por intereses", pf: true, pm: false },
  { c: "615", n: "Régimen de los ingresos por obtención de premios", pf: true, pm: false },
  { c: "616", n: "Sin obligaciones fiscales", pf: true, pm: false },
  { c: "620", n: "Sociedades Cooperativas de Producción que optan por diferir sus ingresos", pf: false, pm: true },
  { c: "621", n: "Incorporación Fiscal", pf: true, pm: false },
  { c: "622", n: "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras", pf: false, pm: true },
  { c: "623", n: "Opcional para Grupos de Sociedades", pf: false, pm: true },
  { c: "624", n: "Coordinados", pf: false, pm: true },
  { c: "625", n: "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas", pf: true, pm: false },
  { c: "626", n: "Régimen Simplificado de Confianza (RESICO)", pf: true, pm: true },
];

/** Valor canónico del Select (debe coincidir con ``SelectItem.value``). */
export function regimenSatSelectValue(entry) {
  if (!entry?.c) return "";
  return `${entry.c} - ${entry.n}`;
}

/** @param {{ c: string, n: string }} entry */
export function formatRegimenSatSelectLabel(entry) {
  return regimenSatSelectValue(entry);
}

/** @param {string} code */
export function findRegimenSatByCode(code) {
  const c = String(code || "").trim();
  if (!c) return null;
  return REGIMENES_SAT.find((r) => r.c === c) || null;
}

/**
 * Normaliza texto de BD/CSF/PDF al valor del Select.
 * Sin esto Radix deja el combobox vacío si el string no coincide exacto
 * (p. ej. solo «601», guion tipográfico «—», o descripción distinta).
 */
export function normalizeRegimenFiscalForSelect(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";
  const exact = REGIMENES_SAT.find((r) => regimenSatSelectValue(r) === s);
  if (exact) return regimenSatSelectValue(exact);
  const m = s.match(/\b(60[1-9]|61[0-6]|62[0-6])\b/);
  if (m) {
    const hit = findRegimenSatByCode(m[1]);
    if (hit) return regimenSatSelectValue(hit);
  }
  return s;
}
